module.exports = __webpack_public_path__ + "img/bitcoin cash.d41590c9.svg";